import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'app-info-snackbar',
    standalone: false,
    templateUrl: './info-snackbar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./info-snackbar.component.scss'],
})
export class InfoSnackbarComponent {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) {}
}
